// third-party
import React from "react";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import BusinessIcon from "@mui/icons-material/Business";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ArticleIcon from "@mui/icons-material/Article";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import EmailIcon from "@mui/icons-material/Email";
import { Lightbulb, Shield, ScrollText } from "lucide-react";
import { Dashboard } from '@mui/icons-material';

// assets
import tagsIcon from "../../assets/icons/layers-logo.svg";
import supportIcon from "../../assets/icons/support.svg";

// icons
const icons = {
  dashboard: () => <Dashboard sx={{ fontSize: 20, color: "inherit" }} />,
  tags: () => <img src={tagsIcon} alt="expert icon" />,
  gamification: () => (
    <CardGiftcardIcon sx={{ fontSize: 20, color: "inherit" }} />
  ),
  contributions: () => <Lightbulb size={18} color="white" />,
  roleGenerate: () => <Shield size={18} color="white" />,
  subAdminLogs: () => <ScrollText size={18} color="white" />,
  corporate: () => <BusinessIcon sx={{ fontSize: 20, color: "white" }} />,
  insights: () => <AutoAwesomeIcon sx={{ fontSize: 20, color: "inherit" }} />,
  blogs: () => <ArticleIcon sx={{ fontSize: 20, color: "inherit" }} />,
  waitlist: () => <PeopleAltIcon sx={{ fontSize: 20, color: "inherit" }} />,
  assistance: () => <img src={supportIcon} alt="assistance icon" />,
  newsletters: () => <EmailIcon sx={{ fontSize: 20, color: "inherit" }} />,
  // sources: () => <img width={18} src={sourcesIcon} alt="sources icon" style={{ filter: 'brightness(0) invert(1)' }} />,
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const managements = {
  id: "group-managements",
  title: "managing : ",
  type: "group",
  children: [
    {
      id: "Dashboard",
      title: "Dashboard",
      type: "item",
      url: "admin/dashboard",
      icon: icons.dashboard,
    },
    {
      id: "Tags",
      title: "Tags",
      type: "item",
      url: "admin/tags",
      icon: icons.tags,
    },
    {
      id: "Gamification",
      title: "Gamification",
      type: "item",
      url: "admin/gamification",
      icon: icons.gamification,
    },
    {
      id: "Corporate",
      title: "Corporate",
      type: "collapse",
      icon: icons.corporate,
      children: [
        {
          id: "Blogs",
          title: "Blogs",
          type: "item",
          url: "admin/corporate",
          icon: icons.blogs,
        },
        {
          id: "Insights",
          title: "Insights",
          type: "item",
          url: "admin/insights",
          icon: icons.insights,
        },
        {
          id: "Waitlist",
          title: "Waitlist",
          type: "item",
          url: "admin/waitlist",
          icon: icons.waitlist,
        },
        {
          id: "Assistance",
          title: "Assistance",
          type: "item",
          url: "admin/assistance",
          icon: icons.assistance,
        },
      ],
    },
    {
      id: "Newsletters",
      title: "Newsletters",
      type: "item",
      url: "admin/newsletters",
      icon: icons.newsletters,
    },
    {
      id: "Contributions",
      title: "Contributions",
      type: "item",
      url: "admin/contributions",
      icon: icons.contributions,
    },
    {
      id: "RoleGenerate",
      title: "Role Generate",
      type: "item",
      url: "admin/role-generate",
      icon: icons.roleGenerate,
    },
    {
      id: "SubAdminLogs",
      title: "Activité sub-admins",
      type: "item",
      url: "admin/sub-admin-logs",
      icon: icons.subAdminLogs,
    },
    // {
    //   id: 'Sources',
    //   title: 'Sources',
    //   type: 'item',
    //   url: 'admin/list-sources',
    //   icon: icons.sources,
    // },
  ],
};

export default managements;
